module.exports = __webpack_public_path__ + "img/56_47.8f281805.png";